/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import './bootstrap.css';

import Grid from '@mui/material/Grid';

export default function Textfield(props) {
	const { label, id, inputType, placeholder, defaultValue = '', name, disabled } = props;
	return (
		<Grid item xs={12} className="form-group">
			<label for={id}>{label}</label>
			<input
				name={name}
				defaultValue={defaultValue}
				type={inputType}
				className="form-control"
				id={id}
				placeholder={placeholder}
				disabled={disabled}
			/>
		</Grid>
	);
}
